var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewOnMapIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.99992H7.50833M7.5 6.66659H7.50833M7.5 11.6666H7.50833M7.5 13.3333H7.50833M7.5 8.33325H7.50833M7.5 9.99992H7.50833M12.5 7.49992H12.5083M12.5 9.16659H12.5083M12.5 14.1666H12.5083M12.5 15.8333H12.5083M12.5 10.8333H12.5083M12.5 12.4999H12.5083M17.5 14.9999L12.5 17.4999L7.5 14.9999L2.5 17.4999V5.83325L7.5 3.33325L12.5 5.83325L17.5 3.33325V14.9999Z",
    stroke: "#76828F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewOnMapIcon);
export default __webpack_public_path__ + "static/media/view-on-map-icon.265d4f6119562ea213eac604e09aa513.svg";
export { ForwardRef as ReactComponent };